//Bajamos el nabvar despues de cierto punto
$(function(){
  $(window).scroll(function(){
    navbarAnimationDown();
  });
});

function validar_email(email){

    var regex = /[\w-\.]{2,}@([\w-]{2,}\.)*([\w-]{2,}\.)[\w-]{2,4}/;

    if(regex.test(email)){
        return true;
    }else{
        return false;
    }

};

//Evitamos agregar el padding-right al modal
$('div.modal').on('shown.bs.modal', function () {
    $(this).css('padding-right', '');
})

function navbarAnimationDown() {
    if($('#buttonTransformSection').length)
    {
        if ($(window).scrollTop() > ($('#buttonTransformSection').offset().top + $('#buttonTransformSection').outerHeight() )) {
            $('.navbar-fixed-top-anim').addClass('navbar-top-responsive');

        }else if ($(window).scrollTop() <= ($('#buttonTransformSection').offset().top + $('#buttonTransformSection').outerHeight() )) {
           $('.navbar-fixed-top-anim').removeClass('navbar-top-responsive');
        }
    }
}


//METEO - Cambiar valores pestañas meteo al dar click a un dia
function activar_btn_day_meteo() {

    $(".btn_day_meteo").click(function(){

        var boton_pulsado = $(this);

        if(!boton_pulsado.hasClass("active")){

            boton_pulsado.siblings('.active').removeClass('active');
            boton_pulsado.addClass("active");

            $.ajaxSetup({
                headers: {'X-CSRF-TOKEN': $(this).data('token')}
            });

            $.ajax({
                url: APP_URL+"/es_ES/ajax-change-tabs-meteo",
                data: {
                    "meteo_report": boton_pulsado.children('.cl_meteo_report').val(),
                    "snow_reports": boton_pulsado.children('.cl_snow_report').val()
                },
                success: function(response) {

                    boton_pulsado.parent().siblings('.cl-tabs-meteo').html(response);

                },
                error: function(e){console.log(e);}
            });

        }

    });

}

/*-- MENU PRINCIPAL --*/

function activar_btn_col3_submenu(btn){

    $('#modalSubmenu .ctn-col3-submenu .btn_submenu_activo').removeClass('btn_submenu_activo');

    if(get_browser_width() > 680){
        $('#modalSubmenu #' + btn).addClass('btn_submenu_activo');
    }

    $('#modalSubmenu .ctn-col4-submenu .ctn-btn-col4-submenu').hide();
    $('#modalSubmenu .ctn-col4-submenu').hide();

    if($('#modalSubmenu #' + btn).data('columnas') > 3){

        $('#modalSubmenu .ctn-col4-submenu').show();
        $('#modalSubmenu #div-' + btn).show();

    }

}

function activar_btn_col2_submenu(btn){

    $('#modalSubmenu .ctn-col2-submenu .btn_submenu_activo').removeClass('btn_submenu_activo');

    if(get_browser_width() > 680){
        $('#modalSubmenu #' + btn).addClass('btn_submenu_activo');
    }

    $('#modalSubmenu .ctn-col4-submenu .ctn-btn-col4-submenu').hide();
    $('#modalSubmenu .ctn-col3-submenu .ctn-btn-col3-submenu').hide();
    $('#modalSubmenu .ctn-col4-submenu').hide();
    $('#modalSubmenu .ctn-col3-submenu').hide();

    if($('#modalSubmenu #' + btn).data('columnas') > 2){

        $('#modalSubmenu .ctn-col3-submenu').show();
        $('#modalSubmenu #div-' + btn).show();

        if(get_browser_width() > 680){

            var id_btn_activo = $('#modalSubmenu #div-' + btn + ' button:first-child').attr('id');
            activar_btn_col3_submenu(id_btn_activo);

        }

    }

}

function activar_btn_col1_submenu(btn){

    $('#modalSubmenu #col1-btn-menu-principal .btn_submenu_activo').removeClass('btn_submenu_activo');

    if(get_browser_width() > 680){
        $('#modalSubmenu #col1-btn-menu-principal #col1-' + btn).addClass('btn_submenu_activo');
    }

    $('#modalSubmenu .ctn-col2-submenu .ctn-btn-col2-submenu').hide();
    $('#modalSubmenu #col2-' + btn).show();

    if(get_browser_width() > 680){

        var id_btn_activo = $('#modalSubmenu #col2-' + btn + ' button:first-child').attr('id');
        activar_btn_col2_submenu(id_btn_activo);

    }

}

var opt_menu;

$('#menu_principal li a, #btn_menu_principal_movil, .btn_menu_principal_mapa').on("click", function() {

    if(get_browser_width() <= 680){

        $('#btn-volver-menu').hide();
        $('#modalSubmenu .btn_submenu_activo').removeClass('btn_submenu_activo');
        $('#modalSubmenu #col1-btn-menu-principal button').parent('p').show();
        $('#modalSubmenu #col1-btn-menu-principal a').parent('p').show();
        $('#modalSubmenu .cl-btn-bottom-col1').show();
        $('#modalSubmenu .ctn-btn-col2-submenu .cl-col-title').show();
        $('#modalSubmenu .ctn-btn-col2-submenu button').parent('p').show();
        $('#modalSubmenu .ctn-btn-col2-submenu a').parent('p').show();
        $('#modalSubmenu .ctn-btn-col2-submenu .cl-col-enlace').show();
        $('#modalSubmenu .ctn-btn-col3-submenu .cl-col-title').show();
        $('#modalSubmenu .ctn-btn-col3-submenu button').parent('p').show();
        $('#modalSubmenu .ctn-btn-col3-submenu a').parent('p').show();
        $('#modalSubmenu .ctn-btn-col3-submenu .cl-col-enlace').show();
        $('#modalSubmenu .ctn-btn-col3-submenu').hide();
        $('#modalSubmenu .ctn-btn-col4-submenu').hide();
        $('#refbtn1').val('');
        $('#refbtn2').val('');
        $('#refbtn3').val('');

    }

    if(($(this).attr('id') == 'btn_menu_principal_movil') || $(this).attr('class') == 'btn_menu_principal_mapa'){
        if(get_browser_width() > 680){
            opt_menu = "btn-menu-principal-0";
        }else{
            opt_menu = "";
        }
    }else{
        opt_menu = $(this).attr('id');
    }

    $('.ctn-logo-cerrar, .ctn-col1-submenu button, .ctn-col1-submenu a,'
        +'.ctn-col2-submenu, .ctn-col2-submenu .cl-col-title, .ctn-col2-submenu button, .ctn-col2-submenu a,'
        +'.ctn-col3-submenu, .ctn-col3-submenu .cl-col-title, .ctn-col3-submenu button, .ctn-col3-submenu a,'
        +'.ctn-col4-submenu, .ctn-col4-submenu .cl-col-title, .ctn-col4-submenu button, .ctn-col4-submenu a').css('opacity', 0);

    activar_btn_col1_submenu(opt_menu);

    $('body').addClass('cl_modal_open');
    $("#modalSubmenu").modal("show");

});

var tiempo1 = 0;
var tiempo2 = 0;
var tiempo3 = 0;
var tiempo4 = 0;
var intervalo = 0;

$("#modalSubmenu").on('shown.bs.modal', function () {

    tiempo1 = 0;
    tiempo2 = 200;
    tiempo3 = 400;
    tiempo4 = 600;
    intervalo = 200;

    $('.ctn-logo-cerrar').animate({opacity: 1}, tiempo1);

    tiempo1 = tiempo1 + intervalo;

    $('.ctn-col1-submenu button, .ctn-col1-submenu a').each(function( index ) {
        $(this).animate({opacity: 1}, tiempo1);
        tiempo1 = tiempo1 + intervalo;
    });

    tiempo2 = tiempo2 + intervalo;
    $('.ctn-col2-submenu').css('opacity',1);

    $('.ctn-btn-col2-submenu:visible .cl-col-title, .ctn-btn-col2-submenu:visible button, .ctn-btn-col2-submenu:visible a').each(function( index ) {
        $(this).animate({opacity: 1}, tiempo2);
        tiempo2 = tiempo2 + intervalo;
    });

    tiempo3 = tiempo3 + intervalo;
    $('.ctn-col3-submenu').css('opacity',1);

    $('.ctn-btn-col3-submenu:visible .cl-col-title, .ctn-btn-col3-submenu:visible button, .ctn-btn-col3-submenu:visible a').each(function( index ) {
            $(this).animate({opacity: 1}, tiempo3);
            tiempo3 = tiempo3 + intervalo;
    });

    tiempo4 = tiempo4 + intervalo;
    $('.ctn-col4-submenu').css('opacity',1);

    $('.ctn-btn-col4-submenu:visible .cl-col-title, .ctn-btn-col4-submenu:visible button, .ctn-btn-col4-submenu:visible a').each(function( index ) {
            $(this).animate({opacity: 1}, tiempo4);
            tiempo4 = tiempo4 + intervalo;
    });

    $('.ctn-logo-cerrar, .ctn-col1-submenu button, .ctn-col1-submenu a,'
        +'.ctn-col2-submenu, .ctn-col2-submenu .cl-col-title, .ctn-col2-submenu button, .ctn-col2-submenu a,'
        +'.ctn-col3-submenu, .ctn-col3-submenu .cl-col-title, .ctn-col3-submenu button, .ctn-col3-submenu a,'
        +'.ctn-col4-submenu, .ctn-col4-submenu .cl-col-title, .ctn-col4-submenu button, .ctn-col4-submenu a').css('opacity', 1);

});

$("#modalSubmenu").on('hide.bs.modal', function(){
    $('.ctn-logo-cerrar').css('opacity',0);
});

var eventos = "";

if(get_browser_width() <= 680){
    eventos = "click";
}else{
    eventos = "click mouseover";
}

$('#modalSubmenu #col1-btn-menu-principal button').on(eventos, function() {

    if(get_browser_width() <= 680){
        $('#modalSubmenu #col1-btn-menu-principal button').parent('p').hide();
        $('#modalSubmenu #col1-btn-menu-principal a').parent('p').hide();
        $('#modalSubmenu .cl-btn-bottom-col1').hide();
        $(this).parent('p').show();
    }

    if(!$(this).hasClass("btn_submenu_activo")){
        var btn_click = $(this).attr('id').replace('col1-','');
        activar_btn_col1_submenu(btn_click);
    }

    if(get_browser_width() <= 680){
        $(this).addClass('btn_submenu_activo');
        $('#btn-volver-menu').show();
        $('#refbtn1').val($(this).parent().parent().parent().attr('id'));
    }

});

$('#modalSubmenu .ctn-btn-col2-submenu button').on(eventos, function() {

    if(get_browser_width() <= 680){
        $('#modalSubmenu .ctn-btn-col2-submenu .cl-col-title').hide();
        $('#modalSubmenu .ctn-btn-col2-submenu button').parent('p').hide();
        $('#modalSubmenu .ctn-btn-col2-submenu a').parent('p').hide();
        $('#modalSubmenu .ctn-btn-col2-submenu .cl-col-enlace').hide();
        $(this).parent('p').show();
    }

    if(!$(this).hasClass("btn_submenu_activo")){
        activar_btn_col2_submenu($(this).attr('id'));
    }

    if(get_browser_width() <= 680){
        $(this).addClass('btn_submenu_activo');

        $('#refbtn2').val($(this).parent().parent().attr('id'));
    }

});

$('#modalSubmenu .ctn-btn-col3-submenu button').on(eventos, function() {

    if(get_browser_width() <= 680){
        $('#modalSubmenu .ctn-btn-col3-submenu .cl-col-title').hide();
        $('#modalSubmenu .ctn-btn-col3-submenu button').parent('p').hide();
        $('#modalSubmenu .ctn-btn-col3-submenu a').parent('p').hide();
        $('#modalSubmenu .ctn-btn-col3-submenu .cl-col-enlace').hide();
        $(this).parent('p').show();
    }

    if(!$(this).hasClass("btn_submenu_activo")){
        activar_btn_col3_submenu($(this).attr('id'));
    }

    if(get_browser_width() <= 680){
        $(this).addClass('btn_submenu_activo');

        $('#refbtn3').val($(this).parent().parent().attr('id'));
    }

});

$('#modalSubmenu .ctn-btn-col2-submenu a').on("mouseover", function() {

    $('#modalSubmenu .ctn-col2-submenu .btn_submenu_activo').removeClass('btn_submenu_activo');

    $('#modalSubmenu .ctn-col4-submenu .ctn-btn-col4-submenu').hide();
    $('#modalSubmenu .ctn-col3-submenu .ctn-btn-col3-submenu').hide();
    $('#modalSubmenu .ctn-col4-submenu').hide();
    $('#modalSubmenu .ctn-col3-submenu').hide();

});

$('#modalSubmenu .ctn-btn-col3-submenu a').on("mouseover", function() {

    $('#modalSubmenu .ctn-col3-submenu .btn_submenu_activo').removeClass('btn_submenu_activo');
    $('#modalSubmenu .ctn-col4-submenu .ctn-btn-col4-submenu').hide();
    $('#modalSubmenu .ctn-col4-submenu').hide();

});

$('#btn-volver-menu').on("click", function() {

    if($('#refbtn3').val() != ""){

        $('.ctn-btn-col4-submenu:visible').hide();

        $('#modalSubmenu .btn_submenu_activo').removeClass('btn_submenu_activo');
        $('#modalSubmenu .ctn-btn-col3-submenu .cl-col-title').show();
        $('#modalSubmenu .ctn-btn-col3-submenu button').parent('p').show();
        $('#modalSubmenu .ctn-btn-col3-submenu a').parent('p').show();
        $('#modalSubmenu .ctn-btn-col3-submenu .cl-col-enlace').show();

        $('.ctn-btn-col1-submenu p:visible button').addClass('btn_submenu_activo');
        $('.ctn-btn-col2-submenu p:visible button').addClass('btn_submenu_activo');

        $('#refbtn3').val('');

    }else if($('#refbtn2').val() != ""){

        $('.ctn-btn-col3-submenu:visible').hide();

        $('#modalSubmenu .btn_submenu_activo').removeClass('btn_submenu_activo');
        $('#modalSubmenu .ctn-btn-col2-submenu .cl-col-title').show();
        $('#modalSubmenu .ctn-btn-col2-submenu button').parent('p').show();
        $('#modalSubmenu .ctn-btn-col2-submenu a').parent('p').show();
        $('#modalSubmenu .ctn-btn-col2-submenu .cl-col-enlace').show();

        $('.ctn-btn-col1-submenu p:visible button').addClass('btn_submenu_activo');

        $('#refbtn2').val('');

    }else if($('#refbtn1').val() != ""){

        $('.ctn-btn-col2-submenu:visible').hide();

        $('#btn-volver-menu').hide();
        $('#modalSubmenu .btn_submenu_activo').removeClass('btn_submenu_activo');
        $('#modalSubmenu #col1-btn-menu-principal button').parent('p').show();
        $('#modalSubmenu #col1-btn-menu-principal a').parent('p').show();
        $('#modalSubmenu .cl-btn-bottom-col1').show();

        $('#refbtn1').val('');

    }

});

/*-- FIN MENU PRINCIPAL --*/

//Modal WEBCAMS - Borrar clase que pasamos al body para que no aparezca la barra scroll al abrir el modal.
$("#modalWebcam").on("hidden.bs.modal", function () {
    $('body').removeClass('cl_modal_open');
    $("#ctn-content-webcam").html('');
    $("#slider-btn-webcams").html('');
    $("#slider-btn-webcams").css('display','none');
    $("#cargando-btn-wc").show();
});


$(document).on("click", '#buscadorEstacion', function(e) {
    updateHomeInfo($("#inputTextEstacion").val());
});

$(document).on("click", '#buscadorWebcams', function(e) {
    searchWebcams($("#inputTextEstacion").val());
});

$(document).on("click", '#buscadorMapas', function(e) {
    searchMapas($("#inputTextEstacion").val());
});

function updateHomeInfo(f_codi)
{

    if (f_codi != "") {
        //Buscador en ajax de estaciones
        $.ajaxSetup({
            headers: {
              'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });

        //Actualizamos meteo

        if(f_codi == '--'){

            $("#tit-result-ajax-meteo h3").html('');
            $("#ctn-result-ajax-meteo").html('');
            $("#tit-result-ajax-meteo").hide();
            $("#ctn-result-ajax-meteo").hide();

            $("#cl-tit-ctn-slide-meteo").show();
            $("#cl-ctn-slide-meteo").show();
            $('#cl-tit-ctn-slide-webcams').show();
            $('#cl-ctn-slide-webcams').show();

        }else{

            $("#tit-result-ajax-meteo h3").html(translations['wcTituloHome']+' '+$("#inputTextEstacion option:selected").text());
            $("#ctn-result-ajax-meteo").html("<div class='cl-cargando-meteo-home'><img class='cl-img-cargando' alt='loading' src='https://www.esqui.com/images/loading.gif'></div>");
            $("#tit-result-ajax-meteo").show();
            $("#ctn-result-ajax-meteo").show();

            $("#cl-tit-ctn-slide-meteo").hide();
            $("#cl-ctn-slide-meteo").hide();
            $('#cl-tit-ctn-slide-webcams').hide();
            $('#cl-ctn-slide-webcams').hide();

            $.ajax({
                type:'POST',
                url: APP_URL+'/es_ES/autocompletar/estaciones/meteo',
                data: {id:f_codi},
                success: function(data){

                    if(data != 0){

                        $("#ctn-result-ajax-meteo").html(data);
                        carousel_init();
                        activar_btn_day_meteo();
                        activar_modal_btn_webcams();

                    }else{

                        $("#tit-result-ajax-meteo").hide();
                        $("#ctn-result-ajax-meteo").html('');

                    }

                }
            });

        }

        //FIN - Actualizamos meteo

        //Actualizamos ofertas
        $.ajax({
            type:'POST',
            url: APP_URL+'/es_ES/autocompletar/estaciones/ofertas',
            data: {id:f_codi},
            success: function(data){
                $("#offers").html(data);
                carousel_init();
            }
        });

        //Actualizamos post del blog
        $.ajax({
            type:'POST',
            url: APP_URL+'/es_ES/autocompletar/estaciones/blog',
            data: {name:$("#inputTextEstacion option:selected").text(),id:f_codi},
            success: function(data){
                $("#blogBoxes").html(data);
                carousel_init();
            }
        });

    }
}

function searchWebcams(f_codi)
{

    if (f_codi != "") {
        //Buscador en ajax de estaciones
        $.ajaxSetup({
            headers: {
              'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });

        if(f_codi == '--'){

            $("#cl-tit-ctn-slide-meteo").hide();
            $("#cl-ctn-slide-meteo").hide();
            $("#cl-tit-ctn-slide-meteo h3").html('');
            $("#cl-ctn-slide-meteo").html('');
            $('#navLinks').show();
            $('.cl-ctn-wc').show();

        }else{

            $("#cl-tit-ctn-slide-meteo").show();
            $("#cl-ctn-slide-meteo").show();
            $("#cl-tit-ctn-slide-meteo h3").html(translations['wcTituloHome']+' '+$("#inputTextEstacion option:selected").text());
            $("#cl-ctn-slide-meteo").html("<div class='cl-cargando-meteo-home'><img class='cl-img-cargando' alt='loading' src='https://www.esqui.com/images/loading.gif'></div>");
            $('#navLinks').hide();
            $('.cl-ctn-wc').hide();

            $.ajax({
                type:'POST',
                url: APP_URL+'/es_ES/autocompletar/estaciones/meteo',
                data: {id:f_codi},
                success: function(data){

                    if(data != 0){

                        $("#cl-ctn-slide-meteo").html(data);
                        carousel_init();
                        activar_btn_day_meteo();
                        activar_modal_btn_webcams();

                    }else{

                        $("#cl-tit-ctn-slide-meteo").hide();
                        $("#cl-ctn-slide-meteo").html('');

                    }

                }
            });

        }

    }

}

function searchMapas(f_codi)
{

    if (f_codi != "") {
        //Buscador en ajax de estaciones
        $.ajaxSetup({
            headers: {
              'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });

        if(f_codi == '--'){

            $("#cl-ctn-slide-mapa").hide();
            $("#cl-ctn-slide-mapa").html('');
            $('#navLinks').show();
            $('.cl-ctn-wc').show();

        }else{

            $("#cl-ctn-slide-mapa").show();
            $("#cl-ctn-slide-mapa").html("<div class='cl-cargando-meteo-home'><img class='cl-img-cargando' alt='loading' src='https://www.esqui.com/images/loading.gif'></div>");
            $('#navLinks').hide();
            $('.cl-ctn-wc').hide();

            $.ajax({
                type:'POST',
                url: APP_URL+'/es_ES/autocompletar/estaciones/mapa',
                data: {id:f_codi},
                success: function(data){

                    if(data != 0){

                        $("#cl-ctn-slide-mapa").html(data);
                        carousel_init();

                    }else{

                        $("#cl-ctn-slide-mapa").html('');

                    }

                }
            });

        }

    }

}

$(document).on("click", '.custom-pagination li a', function(e) {
    e.preventDefault();
    var paginationUrl = $(this).attr('href');
    var inputSearchPost = $("#inputTextSearchPost");

    if ($("#inputTextSearchPostMobile").is(':visible')) {
        inputSearchPost = $("#inputTextSearchPostMobile");
    }

    if (inputSearchPost.val().length > 0) {
        var activeUrl = 'posts/' + inputSearchPost.val();
    }else {
        var activeUrl = $('div[data-name="blog_category"].active-category').attr("data-value");
    }

    $.ajaxSetup({
        headers: {
          'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    $.ajax({
        type:'GET',
        url: APP_URL+'/es_ES/buscadorblog/' + activeUrl + paginationUrl,
        data: {urlTag: $('#inputTag').val()},

        success: function(data){
            $("#blogContent").html(data);
        }
    });
});

$('div[data-name="blog_category"]').on("click", function() {
    if ($(this).attr("data-value") != $('div[data-name="blog_category"].active-category').attr("data-value")) {
        $("#inputTextSearchPost").val("");
        $("#inputTextSearchPostMobile").val("");
        // $('#inputTag').val("");
        $('div[data-name="blog_category"]').removeClass('active-category');
        $(this).addClass('active-category');

        $.ajaxSetup({
            headers: {
              'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });

        $.ajax({
            type:'GET',
            url: APP_URL+'/es_ES/buscadorblog/' + $(this).attr("data-value"),
            data: {urlTag: $('#inputTag').val()},

            success: function(data){
                $("#blogContent").html(data);
            }
        });
    }
});



$('#btn-home-search').on("click", function() {
    if (!$(this).hasClass('btn-search-calc-width')) {
        $(this).addClass('btn-search-calc-width');
    }
});

$('#btn-home-search-back').on("click", function() {
    $('div.input-station-home').removeClass('input-station-home-mobile');
    $('#input-station-container').addClass('d-none');
    $('#btn-home-search').removeClass('invisible');
    $('#btn-home-search').removeClass('btn-search-calc-width');
    $('#input-station-text').removeClass('invisible');
    $(this).addClass('d-none');
});

$('#google-maps-plus').on("click", function() {
    map.setZoom(map.getZoom() + 1);
});

$('#google-maps-minus').on("click", function() {
    map.setZoom(map.getZoom() - 1);
});

$('#collapseLandingText,#collapseLandingText2').on('show.bs.collapse', function (e) {
    var text = $(this).parent().find('.truncated-text');
    var clicked = $(document).find("[href='#" + $(e.target).attr('id') + "']")
    text.addClass('d-none');
    text.removeClass('d-inline');

    clicked.text(translations.readLess);
});

$('#collapseLandingText,#collapseLandingText2').on('hide.bs.collapse', function (e) {
    var text = $(this).parent().find('.truncated-text');
    var clicked = $(document).find("[href='#" + $(e.target).attr('id') + "']")
    text.removeClass('d-none');
    text.addClass('d-inline');

    clicked.text(translations.readMore);
});


$(document).ready(function() {

   //Controlamos que la transicion del input del buscador home
    $('#btn-home-search').on('transitionend webkitTransitionEnd oTransitionEnd', function () {
        if ($('#btn-home-search').hasClass('btn-search-calc-width') && $('#btn-home-search-back').hasClass('d-none')) {
            $('div.input-station-home').addClass('input-station-home-mobile');
            $('#btn-home-search-back').removeClass('d-none');
            $('#input-station-text').addClass('invisible');
            $('#input-station-container').removeClass('d-none');
            $('#btn-home-search').addClass('invisible');
            $('#inputTextEstacion').selectpicker('toggle');
         }
    });



    //Si el email se ha enviado mostramos un modal informando
    if($('#mailSent').val() != 'none') {
        $('#mailStatus').modal('show');
    }

    checkContactForms($("select[name='selectMessage']").val());

    $("select[name='selectMessage']").change(function() {
        checkContactForms($(this).val());
    });

    if ($('#map-station-sheet').length) {
        checkWidthActivateMobileMap();
    }

    $('#btn-map-station-sheet-center').on("click", function() {
        var marker = window['marker_0'];
        googleMapsZoomToPosition(marker.getPosition().lat(), marker.getPosition().lng(), 15);
        googleMapsPanToPosition(marker.getPosition().lat(), marker.getPosition().lng());
    });


    //Activamos botones Meteo
    activar_btn_day_meteo();
    activar_modal_btn_webcams();

    //Bajamos el nabvar despues de cierto punto
    navbarAnimationDown()

    $("#inputTextEstacion").selectpicker({dropupAuto: false});

    if ($("#buscadorEstacion").is(':hidden')) {
        $('#inputTextEstacion').on('changed.bs.select', function (e, clickedIndex, isSelected, previousValue) {
            updateHomeInfo($("#inputTextEstacion").val());
        });
    }

    if ($("#buscadorWebcams").is(':hidden')) {
        $('#inputTextEstacion').on('changed.bs.select', function (e, clickedIndex, isSelected, previousValue) {
            searchWebcams($("#inputTextEstacion").val());
        });
    }

    //Buscador ajax de posts
    if($("#inputTextSearchPost").length || $("#inputTextSearchPostMobile").length) {
        $("#inputTextSearchPost").on('keyup', function() {
            postKeyUp(this.value);
        });

        $("#inputTextSearchPostMobile").on('keyup', function() {
            postKeyUp(this.value);
        });
    }

    //autocomplete del mapa de estaciones
    if($("#inputStationSearchMap").length) {
        function searchMap(label, id) {
            var markerId = $('.owl-item.active').children('div').attr('data-id');
            var marker = window[markerId];
            googleMapsHoverStop(marker);
            $("#inputStationSearchMap").val(label);
            var marker = window['marker_'+id];

            var offset = 0;
            if ($('.toggle-list-map-button').is(':visible') && $('.toggle-list-map-button').hasClass('collapsed')) {
                offset = 25;
            }
            googleMapsPanToPosition(marker.getPosition().lat() + offset, marker.getPosition().lng());
            googleMapsHoverStart(marker, marker.content, false);

            $('#stationIndexCarousel').val('marker_'+id);
        }

        $.ajaxSetup({
            headers: {
              'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });

        $.ajax({
          type:'GET',
          url: APP_URL+'/es_ES/autocompletar/estaciones',

          success: function(data){
            $("#inputStationSearchMap").autocomplete({
                minLength: 3,
                delay: 500,
                source: data.success,

                select: function(event, ui) {
                    event.preventDefault();
                    searchMap(ui.item.label, ui.item.id);
                },
                focus: function(event, ui) {
                    event.preventDefault();
                    searchMap(ui.item.label, ui.item.id);
                }
            });
          }
        });
    }

    /*
    //Calendario desactivado por ahora
    $(document).ready(function() {
        $('#datepicker').datepicker({
            dayNamesMin: $.datepicker.regional["es"].dayNamesShort,
            onChangeMonthYear: function(year, month, inst) {
                var some_Date_var = new Date(inst.selectedYear, inst.selectedMonth, inst.selectedDay);
                $('#currentDate').text($.datepicker.formatDate("MM yy", some_Date_var));
                var some_Date_var = new Date(inst.selectedYear, inst.selectedMonth + 1, inst.selectedDay);
                $('#next').text($.datepicker.formatDate("MM ", some_Date_var) + ' >');
                var some_Date_var = new Date(inst.selectedYear, inst.selectedMonth - 1, inst.selectedDay);
                $('#prev').text('< ' + $.datepicker.formatDate("MM ", some_Date_var));
            }
        });

        $('#next, #prev').on('click', function(e) {
            $('.ui-datepicker-'+e.target.id).trigger("click");
        });
    });
    */
});

$(document).on('mouseenter', 'div[data-name="station-card"]', function (e) {
    var marker = window[$(this).attr("data-id")];
    googleMapsHoverStart(marker, marker.content, true);
});


$(document).on('mouseleave', 'div[data-name="station-card"]', function (e) {
    var marker = window[$(this).attr("data-id")];
    googleMapsHoverStop(marker);
});

$('.toggle-list-map-button > button').click(function() {
    googleMapsHoverStop();

    if ($('.toggle-list-map-button > button').hasClass('collapsed')) {
        var markerId = $('.owl-item.active').children('div').attr('data-id');
        var marker = window[markerId];

        if (marker != null) {
            googleMapsHoverStart(marker);
        }

        $('.toggle-list-map-button > button').find('span').text(translations.map);
        $('.toggle-list-map-button > button').find('svg:eq(1)').addClass("d-none");
        $('.toggle-list-map-button > button').find('svg:eq(0)').removeClass("d-none");
    }else {
        googleMapsHoverStop();
        $("#inputStationSearchMap").val('');
        $("#stationIndexCarousel").val(0);
        $('.toggle-list-map-button > button').find('span').text(translations.list);
        $('.toggle-list-map-button > button').find('svg:eq(0)').addClass("d-none");
        $('.toggle-list-map-button > button').find('svg:eq(1)').removeClass("d-none");
    }
});

$('div[name="pills-accordion"]').click(function() {
    var $window = $(window);
    var windowsize = $window.width();

    if (windowsize <= 1200)
    {
        $('html, body').animate({scrollTop: $("#anchor-to-top").offset().top - 150}, 'fast');
    }
});


function postKeyUp(text)
{
    var timeout = null

    if (text.length >= 3) {
        clearTimeout(timeout)
        timeout = setTimeout(function() {
            $.ajaxSetup({
                headers: {
                  'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            });

            $.ajax({
                type:'GET',
                url: APP_URL+'/es_ES/buscadorblog/posts/'+ text,
                data: {urlTag: $('#inputTag').val()},

                success: function(data){
                    $("#blogContent").html(data);
                }
            });
        }, 500)
    }else if(text.length <= 0) {
        clearTimeout(timeout)
        timeout = setTimeout(function() {
            $.ajaxSetup({
                headers: {
                  'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            });

            $.ajax({
                type:'GET',
                url: APP_URL+'/es_ES/buscadorblog/' + $('div[data-name="blog_category"].active-category').attr("data-value"),
                data: {urlTag: $('#inputTag').val()},

                success: function(data){
                    $("#blogContent").html(data);
                }
            });
        }, 500)
    }

    $("#inputTextSearchPost").val(text);
    $("#inputTextSearchPostMobile").val(text);
}

function checkWidthActivateMobileMap() {

    var $window = $(window);
    var windowsize = $window.width();

    if (windowsize < 992)
    {
        $('#map-station-sheet').on("mousedown", function() {
            //Hacemos el mapa grande
            $("#map_canvas").removeClass('map-sheet-station');
            $("#map_canvas").addClass('map-sheet-station-full-width');
            //Mostramos los botones
            $("#map-station-sheet-buttons").removeClass('d-none');
            $("#map-station-sheet-buttons").addClass('map-sheet-station-buttons');
            $('body').addClass('modal-open');
        });

        $('#btn-map-station-sheet-back').on("click", function() {
            //Devolvemos el mapa a su estado normal
            $("#map_canvas").addClass('map-sheet-station');
            $("#map_canvas").removeClass('map-sheet-station-full-width');
            //Ocultamos los botones
            $("#map-station-sheet-buttons").addClass('d-none');
            $("#map-station-sheet-buttons").removeClass('map-sheet-station-buttons');
            $('body').removeClass('modal-open');
        });
    }
}

function checkContactForms(value)
{
    if (value == 1) {
        $('#transportRequired').removeClass('d-none');
        // $('#school-form').addClass('d-none');
        // $('#school-form :input').attr("disabled", true);
    }else if (value == 2) {
        $('#transportRequired').removeClass('d-none');
        // $('#school-form').removeClass('d-none')
        // $('#school-form :input').attr("disabled", false);
    }else {
        $('#transportRequired').addClass('d-none');
        // $('#school-form').addClass('d-none');
        // $('#school-form :input').attr("disabled", true);
    }
}


$('#searchButtonTransformable').on('click', function(event) {
    if ($('#searchButtonSticky').hasClass('buttonSearchSticky') && !$("#hotelContent").length) {
        event.preventDefault();
        $('html, body').animate({
            scrollTop: $("#searchHousingForm").offset().top
        }, 300);
    }
});

//Newsletter en el footer
$('#btn-newsletter').click(function() {

    if($('#inputEmail').val() == '' || !validar_email($('#inputEmail').val()) || !$('input[name=privacityCheckLetter]').is(':checked')){

        $('#modalErrorNewsletter').modal('show');

    }else{

        $('.cl-loading-news').show();

        $.ajaxSetup({
            headers: {
              'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });

        $.ajax({
            type:'POST',
            url: APP_URL+'/es_ES/subscribeNewsletter',
            data: {
                email: $('#inputEmail').val(),
                idioma: $('html').attr('lang')
            },
            success: function(data){

                if(data == 1){
                    $('#inputEmail').val('');
                    $('input[name=privacityCheckLetter]').prop("checked", false);
                    $('.cl-loading-news').hide();
                    $('#modalEnviadaNewsletter').modal('show');
                }else{
                    $('.cl-loading-news').hide();
                    $('#modalErrorEnvioNews').modal('show');
                }

            }
        });

    }

});

